import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { StripeCustomer } from 'types/payments'
import { getToken } from 'utils/auth'

export async function getStripeCustomer(): Promise<StripeCustomer | null> {
  const userToken = await getToken()
  if (!userToken) {
    return null
  }

  return await makeGetRequest(ApiBase + `/payments/customer`)
}
